import get from 'lodash/get';
import axios from 'axios';
import log from '../../../services/logger_service';

export default function loadParselyTracker(currentState) {
  if (window.PARSELY && window.PARSELY.beacon) {
    const url = window.location.href;
    const navHistory = get(currentState, 'config.navHistory') || [];
    window.PARSELY.beacon.trackPageView({
      url,
      urlref: navHistory[navHistory.length - 1],
      js: 1
    });
  }
}

// Builds a profile of the user's recommendation list, doc https://www.parse.ly/help/api/recommendations/#get-related
export function trainParselyProfile(url) {
  if (window.PARSELY && window.PARSELY.config) {
    const profileURL = url || window.location.href;
    const uuid = get(window, 'PARSELY.config.uuid');

    // Train user base on UUID and post
    axios
      .get(
        `https://api.parsely.com/v2/profile?apikey=fastcompany.com&url=${
          profileURL
        }&uuid=${uuid}`
      )
      .catch(error => {
        log.error('Parsely profile trainer error', error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/client/utils/third_party_trackers/parsely.js